import React, { useState, useEffect } from 'react';
import Skeleton from '@mui/material/Skeleton';
import "./InstaFeed.css"; // Ensure the CSS is correctly applied

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gridTemplateRows: 'repeat(2, 1fr)',
  rowGap: '6%',
  columnGap: '3%'
};

const InstaFeed = () => {
  const [instaItems, setInstaItems] = useState([]);
  const [maxItems, setMaxItems] = useState(getResponsiveItemCount());
  const userId = "7464269820323394";
  const accessToken = "IGQWRORGhuTkl4R3ZA4aTR4YW5pZATEwcWY1NXdYNDZApUWxsenpNbWF4YVVhZA0oxQURiN0xST3B4QnpQUW11OUoxdmhVc3FNSEFsNVFFNzhVODJoYm5xeThzTFFEVUV4LTVEOVFiSXBNZAFAzMDZAMYnM1VnBrV3cyVG8ZD";

  function getResponsiveItemCount() {
    // Responsive item count based on window width
    return window.innerWidth <= 480 ? 6 : 8;
  }

  useEffect(() => {
    const handleResize = () => {
      setMaxItems(getResponsiveItemCount());
    };

    window.addEventListener('resize', handleResize);

    const instaUrl = `https://graph.instagram.com/${userId}/media?access_token=${accessToken}&fields=media_url,media_type,permalink`;
    const fetchMedia = async () => {
      try {
        const response = await fetch(instaUrl);
        const data = await response.json();
        const imagesOnly = data.data.filter(item => item.media_type === 'IMAGE');
        setInstaItems(imagesOnly);
      } catch (error) {
        console.error("Error fetching Instagram media:", error);
      }
    };

    fetchMedia();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (instaItems.length === 0) {
    return (
      <div style={gridStyle}>
        {new Array(maxItems).fill(null).map((_, index) => (
          <Skeleton key={index} variant="rectangular" width="100%" height="100%" />
        ))}
      </div>
    );
  }

  return (
    <div className="main-div" style={gridStyle}>
      {instaItems.slice(0, maxItems).map((item, index) => (
        <a key={index} href={item.permalink}>
          <img className="instagram-pictures" src={item.media_url} alt="" style={{ width: '100%', display: 'block', objectFit: 'cover', aspectRatio: '1' }} />
        </a>
      ))}
    </div>
  );
};

export default InstaFeed;
